<template>
    <div class="scroll-y custom-scrollbar">
        <ion-row>
            <ion-col size="12" size-sm="10" offset-sm="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                <div class="padding">

                    <div class="text-center">

                        <header-challenges title="Plan kwartalny"></header-challenges>

                        <div v-if="$store.getters.getCurrentQuarter.length == 0">
                            <p>Ustalamy Twój cel do realizacji.<br/>Powiadomimy Cię, jak zostanie utworzony.</p>
                        </div>
                        <div v-else>
                            <p class="pd-0 mt-0">Twój cel kwartalny: <strong class="nowrap">{{ $store.getters.getCurrentQuarter.targetQuarterBase || 0 }} punktów</strong></p>
                            <div v-if="$store.getters.getCurrentQuarter.realizationPercent < 100">
                                <p class="pd-0 mt-0">Do zdobycia: <strong class="nowrap">{{ $store.getters.getCurrentQuarter.bonus || 0 }} złotych punktów</strong></p>
                            </div>
                            <div v-else-if="$store.getters.getCurrentQuarter.realizationPercent >= 100">
                                <p class="pd-0 mt-0">Do zdobycia <span v-if="$store.getters.getAboveTarget">min.</span>: <strong class="nowrap">{{ $store.getters.getCurrentQuarter.bonus || 0 }} złotych punktów</strong></p>
                            </div>
                        </div>

                        <h2 class="h2 mt-20 mb-20">Zrealizowano w sumie</h2>
                        <item-progress
                                :title="false"
                                :value="$store.getters.getCurrentQuarter.realizationPercent || 0"
                                suffix="%"
                                :bar="true"
                                label="plan kwartalny"
                                :remaining="$store.getters.getCurrentQuarter.stillLeft || 0"
                                size="large"
                                color="#ff0000">
                        </item-progress>
                        <hr class="mt-40"/>
                    </div>

                    <div class="list">
                        <h2 class="h2 mt-20">Szczegóły</h2>
                        <div class="item mb-20" v-for="item in $store.getters.getQuarterDetails">
                            <item-progress
                                    :title="item.month"
                                    :value="item.realizationPercent"
                                    suffix="%"
                                    :bar="true"
                                    label="plan miesięczny"
                                    :remaining="item.stillLeft"
                                    size="large"
                                    color="#ff0000">
                            </item-progress>
                            <div v-if="item.realizationPercent < 100">
                                <p class="pd-0 text-left">Do zdobycia min.: <strong class="nowrap">{{ item.bonus || 0 }} złotych punktów</strong></p>
                            </div>
                            <div v-else-if="item.realizationPercent >= 100">
                                <p class="pd-0 text-left">Zdobyto: <strong class="nowrap">{{ item.bonus || 0 }} złotych punktów</strong></p>
                            </div>
                        </div>
                        <div v-if="$store.getters.getQuarterDetails.length === 0">Brak danych</div>
                        <div class="text-left mt-10">
                            <button class="link" @click="goToMonthlyTab">
                                <svg><use xlink:href="#icon-details"></use></svg>
                                <span>Wróć do wyzwania miesięcznego</span>
                            </button>
                        </div>
                    </div>

                </div>
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
    import HeaderChallenges from "./../Header.vue";
    import ItemProgress from "../../../items/ItemProgress.vue";

    export default {
        name: 'QuarterlyTab',
        components: { HeaderChallenges, ItemProgress },
        methods: {
            goToMonthlyTab: function () {
                this.$router.push({name: 'ChallengesMonthly'})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .list{
        margin: 40px 0;
        text-align: center;
    }
</style>